import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { AlarmType } from 'types'
import { fetchOne, fetchAll, triggerSOS } from 'UserApp/store/alarm/actions'
import { selectAlarm, selectAlarms } from 'UserApp/store/alarm/selectors'
import { selectCount as selectPetCount } from 'UserApp/store/pets/selectors'
import { selectField } from 'UserApp/store/user/selectors'
import AlarmScreen from 'UserApp/screens/Alarm'

class AlarmScreenContainer extends React.PureComponent {
  static propTypes = {
    alarm: PropTypes.shape(AlarmType),
    alarms: PropTypes.arrayOf(PropTypes.shape(AlarmType)),
    fetchOne: PropTypes.func,
    fetchAll: PropTypes.func,
  }

  state = {
    isLoading: true,
  }

  async componentDidMount() {
    const { fetchOne, fetchAll } = this.props
    try {
      await fetchAll()
      // await fetchOne()
      
    } catch (e) {
      // no alarm
    }
    this.setState({ isLoading: false })
  }

  handleTriggerSOS = async () => {
    const { triggerSOS, history } = this.props
    this.setState({ isLoading: true })

    try {
      await triggerSOS()
    } catch (e) {
      // no alarm
    }

    history.push('/alarm')
    this.setState({ isLoading: false })
  }

  generateProps = () => {
    const alarmGoingOff = this.props.alarms?.find(alarm => alarm.isFiring || alarm.isExpired || alarm.isComplete)
    return {
      ...this.props,
      ...this.state,
      onTriggerSOS: this.handleTriggerSOS,
      isGoingOff: alarmGoingOff !== undefined,
      hasAlarm: this.props.alarm,
    }
  }

  render() {
    const props = this.generateProps()
    return <AlarmScreen {...props} />
  }
}

export default connect(
  (state) => ({
    locationDetails: selectField(state, `locationDetails`),
    alarm: selectAlarm(state),
    alarms: selectAlarms(state),
    petCount: selectPetCount(state),
  }),
  { fetchOne, fetchAll, triggerSOS },
)(AlarmScreenContainer)
